<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: ' 按月还款计划表'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :sort.sync="sort"
        :is-pagination-show="false"
        ref="tableData"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery, xmlBuildSort} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "RepayReportByMonthList",
      data(){
        return{
          applicationStatus: 'Pending Approval',
          roleData:{},
          dealerOptions:[],
          tableData: {
            count: 0,
            data: []
          },
          sort: {
            fields: ['fi__transactionNo', 'rex__balanceAmount'],
            default: {
              prop: 'fi__transactionNo',
              order: 'ascending'
            },
            params: {}
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
            {
              label: '导出',
              class: 'el-icon-download el-button--primary',
              clickHandler:()=> {
                this.$refs.tableData.$refs.DataTableFilterForm.$refs.DataTableFilterForm.validate(valid=> {
                  if(valid) {
                    let routeData = this.$router.resolve({
                      path: '/ix/fang/financing/reporting/RepaymentStats.List?format=xls',
                      query: Object.assign({
                        pageSize:0,
                        'repayDate':this.filters.form.plan__repayDate,
                      }, {}, xmlBuildQuery(this.filters))
                    });
                    window.open(routeData.href.replace('#/', '/'), '_blank');
                  }
                })
              }
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              d__dealerId:'',
              fi__customerName:'',
              plan__repayDate:'',
              fi__transactionNo:'',
              c__customerContactNo:'',
              fi__repaymentFormula:''
            },
            rules: {
              plan__repayDate:{
                required:true,
                message: '不能为空'
              }
            },
            columns: [
              {
                label: '渠道商',
                component: 'el-select',
                field: 'd__dealerId',
                options:[],
                span: 12
              },

              {
                label: '应还款月',
                component: 'el-date-picker',
                field: 'plan__repayDate',
                op:'eq',
                type: 'month',
                valueFormat:'yyyy-MM-01 00:00:00',
                span: 12,

              },
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',

              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'fi__customerName',

              },
              {
                label: '客户手机号',
                component: 'el-input',
                field: 'c__customerContactNo',

              },
              {
                label: '还款方式',
                component: 'el-select',
                field: 'fi__repaymentFormula',
                options: [
                  {
                    label: '全部',
                    value: ''
                  },
                  {
                    label: '等额本息',
                    value: 'DEBX'
                  },
                  {
                    label: '先息后本',
                    value: 'XXHB'
                  },

                ],
                op: 'eq',
                span: 12
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            },
            onReset: ()=> {
              this.filters.form = {
                d__dealerId:'',
                fi__customerName:'',
                plan__repayDate:'',
                pan__sequenceNo:'',
              }
              this.tableData= {
                count: 0,
                  data: []
              }
            }
          },
          balanceAmounts:0,
          principalAmount:0,
          interestAmount:0,
          subtotalAmount:0,
          balanceAmount:0,
        }
      },
      computed:{
        columns: function(){
          return [
            {
              name:'序号',
              field: 'lineNo'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '客户姓名',
              field: 'fi__customerName'
            },
           /* {
              label: '渠道商',
              field: 'd__dealerName'
            },*/
            {
              label: '贷款余额',
              field: 'balanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '起息日',
              field: 'plan__frDate',
              formatter: function (r,c,v) {
                if(v)
                return moment(v).format('YYYY-MM-DD')
                else
                return ''
              }
            },
            {
              label: '止息日',
              field: 'plan__toDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
                else
                  return ''
              }
            },
            {
              label: '应还款日',
              field: 'plan__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
                else
                  return ''
              }
            },
            {
              label: '计息天数',
              field: 'plan__days'
            },
            {
              label: '利率(%)',
              field: 'fi__interestRate'
            },
            {
              label: '应还本金',
              field: 'plan__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '应还利息',
              field: 'plan__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '小计',
              field: 'plan__subtotalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收罚息',
              field: 'rex__compoundInterest',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收复利',
              field: 'rex__overdueFine',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '到账金额',
              field: 'rex__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '上期余额',
              field: 'rex__exBalanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '多收金额',
              field: 'rex__excessAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '差额',
              field: 'rex__balanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '还款码',
              field: 'fi__repaymentCode'
            },
          ]
        },
        filterParams: {
          get: function() {
            return {

            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
        sort: function () {
          this.getData()
        }
      },

      mounted() {
        this.getDealerList()
      },
      methods: {
        getData: function () {
          xhr.getRepaymentStatsList(
            Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters), xmlBuildSort(this.sort.params)),
            res => {
              try {
                this.balanceAmounts = 0
                this.principalAmount = 0
                this.interestAmount = 0
                this.subtotalAmount = 0
                this.balanceAmount = 0

                let compoundInterest = 0
                let overdueFine = 0
                let excessAmount = 0
                let repayAmount = 0
                this.tableData = res.data
                this.tableData.data.forEach(item=>{
                  if(item.balanceAmount){
                    this.balanceAmounts = this.balanceAmounts +parseFloat(item.balanceAmount)*10000
                  }
                  if(item.plan__principalAmount){
                    this.principalAmount = this.principalAmount +parseFloat(item.plan__principalAmount)*10000
                  }
                  if(item.plan__interestAmount){
                    this.interestAmount = this.interestAmount +parseFloat(item.plan__interestAmount)*10000
                  }
                  if(item.plan__subtotalAmount){
                    this.subtotalAmount = this.subtotalAmount +parseFloat(item.plan__subtotalAmount)*10000
                  }
                  if(item.rex__balanceAmount  ){
                    this.balanceAmount   = this.balanceAmount +parseFloat(item.rex__balanceAmount  )*10000
                  }

                  if(item.rex__compoundInterest  ){
                    compoundInterest   = compoundInterest +parseFloat(item.rex__compoundInterest  )*10000
                  }

                  if(item.rex__overdueFine  ){
                    overdueFine   = overdueFine +parseFloat(item.rex__overdueFine  )*10000
                  }
                  if(item.rex__excessAmount  ){
                    excessAmount   = excessAmount +parseFloat(item.rex__excessAmount  )*10000
                  }
                    if(item.rex__repayAmount  ){
                        repayAmount   = repayAmount +parseFloat(item.rex__repayAmount  )*10000
                    }
                })
                this.tableData.data.push({
                  lineNo:'合计：',
                  fi__customerName:'共'+this.tableData.count+'笔',
                  balanceAmount : parseFloat(this.balanceAmounts/10000).toFixed(2),
                  plan__principalAmount : parseFloat(this.principalAmount/10000).toFixed(2),
                  plan__interestAmount : parseFloat(this.interestAmount/10000).toFixed(2),
                  plan__subtotalAmount : parseFloat(this.subtotalAmount/10000).toFixed(2),
                  rex__balanceAmount : parseFloat(this.balanceAmount/10000).toFixed(2),
                  rex__compoundInterest : parseFloat(compoundInterest/10000).toFixed(2),
                  rex__overdueFine : parseFloat(overdueFine/10000).toFixed(2),
                  rex__excessAmount : parseFloat(excessAmount/10000).toFixed(2),
                  rex__repayAmount: parseFloat(repayAmount/10000).toFixed(2),
                })

              } catch (e) {

              }
            })
        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.filters.columns[0].options = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/RepayReportByMonthList.vue